module.exports = __webpack_public_path__ + "static/media/vlajka_gb_gray.a3d2b4fc.svg";